// import PermissionError from "@Components/Errors/Permission";
import AccessDeniedPage from "@Components/other_pages/access-denied/page";
import { IsNullOrWhiteSpace } from "@Utils/Utils";

import routes from "@/routers/routes";
import useAuthStore from "@Stores/AuthStore";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/// manage the routes and accessability (role or permission)
/**
 * Provider the accessability
 *
 * Note: you can use in route or functions etc...
 *
 * @function PrivateRoutes()
 *
 */
export const PrivateRoutes = ({
    children,
    // role,
    permission,
    noContent = false,
}: {
    children?;
    role?: string | string[];
    permission?: string | string[];
    noContent: boolean;
}) => {
    const { logOut, isAuthorized, auth } = useAuthStore.getState();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthorized) {
            navigate(routes.auth.login);
            logOut();
            return;
        }
    }, [isAuthorized, logOut]);

    if (!isAuthorized) {
        navigate(routes.auth.login);
        logOut();
        return;
    }

    // it Developer
    // if (auth.user.isMana) return children;

    if (auth === undefined || auth === null) {
        return navigate(routes.auth.login);
    }

    // only one role
    // if (typeof role === "string" && !IsNullOrWhiteSpace(role))
    //     return auth.user?.roles?.includes(role) ? (
    //         children
    //     ) : noContent ? (
    //         <AccessDeniedPage />
    //     ) : (
    //         <></>
    //     );

    // only one permission
    if (!IsNullOrWhiteSpace(permission))
        return auth.user?.permissions?.includes(permission as string) ? (
            children
        ) : noContent ? (
            <AccessDeniedPage />
        ) : (
            <></>
        );

    // list of role
    // if (Array.isArray(role) && !role.isEmpty())
    //     return auth.user?.roles?.includes(role) ? (
    //         children
    //     ) : noContent ? (
    //         <AccessDeniedPage />
    //     ) : (
    //         <></>
    //     );

    // list of permissions
    if (Array.isArray(permission) && !permission.isEmpty())
        return (auth.user?.permissions || []).find((p) =>
            permission.includes(p),
        ) ? (
            children
        ) : noContent ? (
            <AccessDeniedPage />
        ) : (
            <></>
        );

    // role and permissions
    // if (
    //     // typeof role === "string" &&
    //     typeof permission === "string" &&
    //     // !IsNullOrWhiteSpace(role) &&
    //     !IsNullOrWhiteSpace(permission)
    // )
    //     return auth.user?.roles == role &&
    //         (auth.user?.role?.permissions || []).find(
    //             (p) => p === permission,
    //         ) ? (
    //         children
    //     ) : noContent ? (
    //         <AccessDeniedPage />
    //     ) : (
    //         <></>
    //     );

    // one role and list of permissions
    // if (
    //     typeof role === "string" &&
    //     !IsNullOrWhiteSpace(role) &&
    //     Array.isArray(permission) &&
    //     !permission.isEmpty()
    // )
    //     return auth.user?.roles == role &&
    //         (auth.user?.role?.permissions || []).find((p) =>
    //             permission?.includes(p),
    //         ) ? (
    //         children
    //     ) : noContent ? (
    //         <AccessDeniedPage />
    //     ) : (
    //         <></>
    //     );

    //  list of role and one permission
    // if (
    //     Array.isArray(role) &&
    //     !role.isEmpty() &&
    //     !IsNullOrWhiteSpace(permission)
    // )
    //     return role?.includes(auth.user?.roles ?? "") &&
    //         (auth.user?.role?.permissions || []).find(
    //             (p) => p == permission,
    //         ) ? (
    //         children
    //     ) : noContent ? (
    //         <AccessDeniedPage />
    //     ) : (
    //         <></>
    //     );

    // list of role and list of permission
    // if (
    //     Array.isArray(permission) &&
    //     !permission.isEmpty() &&
    //     Array.isArray(role) &&
    //     !role.isEmpty()
    // )
    //     return role?.includes(auth.user?.roles ?? "") &&
    //         (auth.user?.role?.permissions || []).find((p) =>
    //             permission.includes(p),
    //         ) ? (
    //         children
    //     ) : noContent ? (
    //         <AccessDeniedPage />
    //     ) : (
    //         <></>
    //     );
};
